export default {
  title: 'Precificação por Usuário',
  description: 'Configure as faixas de cobrança por usuários adicionais.',
  labels: {
    new: 'Nova faixa',
  },
  form: {
    title: 'Faixa de precificação por usuário',
  },
  groups: {
    range: 'Faixa de usuários',
    values: 'Valores por usuário adicional',
  },
  fields: {
    minUsers: 'Usuários a partir de',
    maxUsers: 'Usuários até',
    currency: 'Moeda',
    price: 'Valor por usuário',
    priceUsd: 'Valor por usuário (USD)',
    active: 'Ativa',
  },
};
